import dialogs from '../helpers/registered-dialogs';

const getDialogByType = (modalType) => dialogs.get(modalType);

export default getDialogByType;
